module.exports = __webpack_public_path__ + "static/can-2bec149625d1050250bb87efcb8a1602.mp4";